/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_GeneratingInputs */

const zh_preview_generating = /** @type {(inputs: Preview_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成中...`)
};

const en_preview_generating = /** @type {(inputs: Preview_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating...`)
};

const es_preview_generating = /** @type {(inputs: Preview_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando...`)
};

/**
* | output |
* | --- |
* | "Generating..." |
*
* @param {Preview_GeneratingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const preview_generating = /** @type {((inputs?: Preview_GeneratingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_GeneratingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_preview_generating(inputs)
	if (locale === "en") return en_preview_generating(inputs)
	return es_preview_generating(inputs)
});